import { formatDateString } from '~libs/dayjs';

/**
 * How a Support at Home service's date period reads to a provider.
 *
 * Kept in its own module, apart from `lib/derive`, because `derive` imports the Redux store at its
 * first line. Anything that reaches for one of these two values drags the whole store graph in with
 * it, and a column definition loaded early enough in the import order then initialises `store`
 * before the slices it depends on exist - which surfaces as the opaque
 * "`name` is a required option for createSlice". `derive` re-exports both, so existing callers are
 * unaffected.
 */

/** A service with no end date is available indefinitely - a different thing from an unknown end. */
export const OPEN_ENDED_LABEL = 'Ongoing';

/**
 * A service's period as "start - end".
 *
 * Always "start - end", even with no end date. Reading "01/Mar/2025 onwards" beside
 * "01/Mar/2025 - 30/Sep/2026" made the two look like different kinds of value and put the dates in
 * different places down the column; keeping the separator holds the shape, and a word in the end
 * slot says what it is rather than trailing off after the dash as though a date were missing.
 */
export const formatServicePeriod = (start_date?: string | null, end_date?: string | null): string => {
  if (!start_date) return '';

  const from = formatDateString(start_date);
  return `${from} - ${end_date ? formatDateString(end_date) : OPEN_ENDED_LABEL}`;
};
